import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const AuthWall = () => {
  const authHelper = useAuth();
  if( !( authHelper?.authObj && authHelper?.authObj.accessToken ) ){
    return <Navigate to={`/login?redirect=${location.pathname}`} replace />;
  }
  if( authHelper.interceptReady ){
    return <Outlet/>;
  }
  return null;
};

export default AuthWall;